@if (form) {
  <form [formGroup]="form">
    <label>{{ 'RESET_PW_PASSWORD_CONFIRMATION' | translate }}</label>
    <em-input
      [label]="'RESET_PW_PASSWORD_CONFIRMATION' | translate"
      matInput
      type="password"
      formControlName="confirmPassword"
      >
      <em-error>
        @if (form?.get('confirmPassword')?.hasError('required')) {
          {{ 'VALIDATION_FIELD_REQUIRED' | translate }}
          }@else if(form?.get('confirmPassword')?.hasError('passwordMismatch') &&
          form?.get('confirmPassword')?.touched){
          {{ 'ACCOUNT_NEW_PASSWORD_CONFIRMATION_MISMATCH' | translate }}
        }
      </em-error>
    </em-input>
  </form>
}
